/**
 * AbortController helpers.
 */
export function createAbortable() {
	let controller = null;

	return {
		start() {
			this.abort();
			controller = new AbortController();
			return controller.signal;
		},
		abort() {
			if (controller) {
				controller.abort();
				controller = null;
			}
		},
		get signal() {
			return controller ? controller.signal : null;
		},
	};
}
